<template>
  <span class="node d-flex px-1">
    <b-badge
      :id="`node_${node.id}`"
      tabindex="0"
      class="node-badge"
    >
      {{ renderNode }}
    </b-badge>
    <b-popover :target="`node_${node.id}`" boundary="viewport" variant="danger" triggers="click blur" placement="top">
      <span @click="onNodeRemove" class="clickable">
        Haz click aquí para eliminar
      </span>
    </b-popover>
  </span>
</template>

<script>
export default {
  name: 'Node',
  props: {
    node: Object
  },
  methods: {
    onNodeRemove () {
      this.$root.$emit('bv::hide::popover')
      this.$emit('node-remove')
    }
  },
  computed: {
    renderNode () {
      if (this.node?.type === 'expression') {
        return `${this.node.propertyLabel} ${this.node.validationLabel} ${this.node.valueLabel}`
      }
      return this.node.propertyLabel
    }
  }
}
</script>

<style scoped>
.node {
  font-size: 1.3rem;
}
.node-badge {
  line-height: 1.5;
  font-weight: normal;
}
</style>
